var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stmnt" }, [
    _vm.selectedState === "NonOpen"
      ? _c("div", { staticClass: "head" }, [
          _c(
            "div",
            {
              staticClass: "inhead bordered clickable",
              on: {
                click: function($event) {
                  return _vm.togglePickers()
                }
              }
            },
            [
              _c("div", [
                _c("span", { staticClass: "minittl" }, [_vm._v("date range")]),
                _vm._v(" "),
                _c("span", { staticClass: "ttl filtertgl" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("moment")(_vm.historyDateRange.from, "MMM Do YYYY")
                    ) +
                      " - " +
                      _vm._s(
                        _vm._f("moment")(_vm.historyDateRange.to, "MMM Do YYYY")
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "pd-icon pd-icon-calendar" })
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    1 === 2
      ? _c("div", [
          _vm._v(
            "\n    x " +
              _vm._s(_vm.isGeolocated) +
              " x| " +
              _vm._s(_vm.geolocationMessage)
          ),
          _c("br"),
          _vm._v(
            "\n    bbs: " +
              _vm._s(_vm.bbStatus) +
              " | bbs.state: " +
              _vm._s(_vm.bbStatus.state) +
              " | bb.bet: " +
              _vm._s(_vm.bb.bet)
          ),
          _c("br"),
          _vm._v(
            "\n    cmp: " +
              _vm._s(_vm.filterDateRange.from) +
              " - " +
              _vm._s(_vm.filterDateRange.to) +
              "]\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", { staticClass: "stmnt-block note" }, [
          _vm._v(_vm._s(_vm.$t("Statement.LoginToSeeBetHistory")))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn &&
    (_vm.filterVisiblePicker == "from" || _vm.filterVisiblePicker == "to")
      ? _c("div", { staticClass: "stmnt-fdaterang-ri" }, [
          _c(
            "div",
            { staticClass: "fdr-wrap" },
            [
              _c("div", { staticClass: "fdr-heading" }, [
                _c("div", { staticClass: "stmnt-btnset x2 fullw" }, [
                  _c("div", { staticClass: "sbtnwrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "stmnt-btn datebtn",
                        class: { active: _vm.filterVisiblePicker === "from" },
                        on: {
                          click: function($event) {
                            return _vm.selectPicker("from")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "headhint" }, [
                          _vm._v(_vm._s(_vm.$t("Statement.daterange.from")))
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.filterDateRange.from,
                              "ddd, MMM Do YYYY"
                            )
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sbtnwrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "stmnt-btn datebtn",
                        class: { active: _vm.filterVisiblePicker === "to" },
                        on: {
                          click: function($event) {
                            return _vm.selectPicker("to")
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "headhint" }, [
                          _vm._v(_vm._s(_vm.$t("Statement.daterange.to")))
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.filterDateRange.to,
                              "ddd, MMM Do YYYY"
                            )
                          )
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.filterDateRange.from && _vm.filterVisiblePicker === "from"
                ? _c("v-date-picker", {
                    attrs: {
                      "show-current": _vm.filterDateRange.to,
                      "full-width": true,
                      "no-title": true,
                      max: _vm.filterDateRange.to,
                      "event-color": _vm.calcPickerRangeDate,
                      events: _vm.calcPickerRangeDate
                    },
                    model: {
                      value: _vm.filterDateRange.from,
                      callback: function($$v) {
                        _vm.$set(_vm.filterDateRange, "from", $$v)
                      },
                      expression: "filterDateRange.from"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.filterDateRange.from && _vm.filterVisiblePicker === "to"
                ? _c("v-date-picker", {
                    attrs: {
                      "show-current": _vm.filterDateRange.from,
                      "full-width": true,
                      "no-title": true,
                      min: _vm.filterDateRange.from,
                      max: _vm._f("moment")(new Date(), "YYYY-MM-DD"),
                      "event-color": _vm.calcPickerRangeDate,
                      events: _vm.calcPickerRangeDate
                    },
                    model: {
                      value: _vm.filterDateRange.to,
                      callback: function($$v) {
                        _vm.$set(_vm.filterDateRange, "to", $$v)
                      },
                      expression: "filterDateRange.to"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "fdr-footer" }, [
                _c("div", { staticClass: "stmnt-btnset x2 fullw" }, [
                  _c("div", { staticClass: "sbtnwrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "stmnt-btn sb-white",
                        on: {
                          click: function($event) {
                            return _vm.selectPicker("none")
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Statement.dialog.Close")))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sbtnwrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "stmnt-btn sb-blue",
                        on: {
                          click: function($event) {
                            return _vm.applyPickers("from")
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("Statement.dialog.Apply")))
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn &&
    _vm.bb &&
    _vm.bb.bet &&
    _vm.bb.bet.SB &&
    (!_vm.bbStatus || _vm.bbStatus.state !== "quoting")
      ? _c("div", { staticClass: "stmnt-bbquote" }, [
          _c("div", { staticClass: "bbq-wrap" }, [
            _c("div", { staticClass: "block bbq-heading" }, [
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("Statement.CashOutConfirmation")))
              ]),
              _c(
                "span",
                {
                  staticClass: "bbq-btn bbq-btn-close",
                  on: {
                    click: function($event) {
                      return _vm.cancelBuyBack()
                    }
                  }
                },
                [_vm._v("x")]
              )
            ]),
            _vm._v(" "),
            _vm.bb.bet.Quote !== _vm.bb.quote.Amount
              ? _c("div", { staticClass: "block bbq-info" }, [
                  _c("div", { staticClass: "bbq-infomsg bbreoffer" }, [
                    _vm._v(
                      _vm._s(_vm.$t("Statement.CashoutReofferNotification"))
                    )
                  ])
                ])
              : _c("div", { staticClass: "block bbq-info" }, [
                  _c(
                    "div",
                    { staticClass: "bbq-infomsg stmnt-infocon icblue" },
                    [_vm._v(_vm._s(_vm.$t("Statement.CashOutInfo")))]
                  )
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "block bethead" }, [
              _c("div", { staticClass: "betoverview" }, [
                _vm.bb.bet.SB && _vm.bb.bet.SB.IDFOBetType == "S"
                  ? _c("div", { staticClass: "betttl" }, [
                      _vm._v(_vm._s(_vm.bb.bet.SB.Legs[0].Event))
                    ])
                  : _vm.bb.bet.SB && _vm.bb.bet.SB.BetTypeExt
                  ? _c("div", { staticClass: "betttl" }, [
                      _vm._v(_vm._s(_vm.bb.bet.SB.BetTypeExt) + " "),
                      _vm.bb.bet.SB && _vm.bb.bet.SB.BetTypeSpread
                        ? _c("span", { staticClass: "spreadhint" }, [
                            _vm._v(
                              _vm._s(_vm.bb.bet.SB.BetTypeSpread) +
                                " " +
                                _vm._s(_vm.$t("Statement.spreadHint"))
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm.bb.bet.SB &&
                    _vm.bb.bet.SB.Units &&
                    _vm.bb.bet.SB.Units > 1
                  ? _c("div", { staticClass: "betttl" }, [
                      _vm._v(_vm._s(_vm.bb.bet.SB.BetType) + " "),
                      _vm.bb.bet.SB
                        ? _c("span", { staticClass: "unitshint" }, [
                            _vm._v(
                              "x" +
                                _vm._s(_vm.bb.bet.SB.Units) +
                                " " +
                                _vm._s(_vm.$t("Statement.unitsHint"))
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm.bb.bet.SB
                  ? _c("div", { staticClass: "betttl" }, [
                      _vm._v(_vm._s(_vm.bb.bet.SB.BetType))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bb.bet.Status === "Open"
                  ? _c("div", { staticClass: "betrefs" }, [
                      _vm._v(
                        "#" +
                          _vm._s(_vm.bb.bet.InvoiceSlip) +
                          " - " +
                          _vm._s(
                            _vm._f("moment")(
                              _vm._f("date")(
                                _vm.bb.bet.Created,
                                "yyyy-MM-ddThh:mm:ss"
                              ),
                              _vm.dateFormats.longDateTime
                            )
                          )
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "block betbbquotes" }, [
              _c("div", { staticClass: "betbbquote" }, [
                _vm._v("Cash Out Value "),
                _c(
                  "span",
                  {
                    staticClass: "money",
                    class: {
                      "blink blink-orange":
                        _vm.bb.bet.Quote !== _vm.bb.quote.Amount
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("currency")(_vm.bb.quote.Amount)))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "betbbquote" }, [
                _vm._v("Potential Returns "),
                _vm.bb.bet.SB.Potential && _vm.bb.bet.SB.Potential > 0
                  ? _c("span", { staticClass: "money" }, [
                      _vm._v(
                        _vm._s(_vm._f("currency")(_vm.bb.bet.SB.Potential))
                      )
                    ])
                  : _c("span", { staticClass: "money" }, [_vm._v("-")])
              ])
            ]),
            _vm._v(" "),
            !_vm.isGeolocated && _vm.isLoggedIn
              ? _c("div", { staticClass: "block" }, [
                  _c("div", { staticClass: "bbq-infomsg notgeolocated" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("BetSlip.notLocated." + _vm.state)))
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("BetSlip.tryAgain." + _vm.state)))
                    ])
                  ])
                ])
              : _c("div", { staticClass: "block buyback" }, [
                  _c(
                    "button",
                    {
                      staticClass: "stmnt-btn sb-blue",
                      on: {
                        click: function($event) {
                          return _vm.settleBuyBack(
                            _vm.bb.bet.SB.IDFOBet,
                            _vm.bb.bet
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Statement.CashOutConfirmCashout")))]
                  ),
                  _vm._v(" "),
                  _vm.bbStatus &&
                  (_vm.bbStatus.state === "settling" ||
                    _vm.bbStatus.state === "quoting")
                    ? _c(
                        "div",
                        { staticClass: "bb-loading" },
                        [_c("circle-loader")],
                        1
                      )
                    : _vm._e()
                ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn && _vm.bb && _vm.bb.msg
      ? _c(
          "div",
          {
            staticClass: "stmnt-bbstatemsg",
            on: {
              click: function($event) {
                return _vm.cancelBuyBack()
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "msg stmnt-infocon",
                class:
                  " msg-" + _vm.bb.msgtype + " stmnt-infocon-" + _vm.bb.msgtype
              },
              [_vm._v(_vm._s(_vm.bb.msg))]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.filterVisiblePicker == "none" &&
    !(_vm.historyStatus && _vm.historyStatus.fetching === true) &&
    (!_vm.isLoggedIn || !_vm.history || _vm.history.length < 1)
      ? _c("div", { staticClass: "stmnt-notif" }, [
          _vm.history &&
          _vm.history.length === 0 &&
          _vm.selectedState === "Open"
            ? _c("div", { staticClass: "stmnt-block note" }, [
                _c("span", { staticClass: "main" }, [
                  _vm._v(_vm._s(_vm.$t("Statement.NoOpenRecordsToShow")))
                ])
              ])
            : _vm.history && _vm.history.length === 0
            ? _c("div", { staticClass: "stmnt-block note" }, [
                _c("span", { staticClass: "main" }, [
                  _vm._v(_vm._s(_vm.$t("Statement.NoSettledRecordsToShow")))
                ])
              ])
            : _vm.history && _vm.history.length === 0
            ? _c("div", { staticClass: "stmnt-ctrls" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn sb-blue",
                    on: {
                      click: function($event) {
                        return _vm.gotoLiveBetting()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "btn__content" }, [
                      _vm._v(_vm._s(_vm.$t("Statement.GoToLiveBetting")))
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn && _vm.filterVisiblePicker == "none"
      ? _c(
          "div",
          { staticClass: "stmnt-bets" },
          [
            _vm._l(_vm.history, function(bet) {
              return _c(
                "div",
                {
                  staticClass: "stmnt-bet",
                  class:
                    "betstatus-" +
                    bet.statusInner +
                    (bet.SB &&
                    bet.SB.IDFOBet === _vm.bb.idfobet &&
                    _vm.bb.msgtype === "nok"
                      ? " error-outline"
                      : "")
                },
                [
                  _c("div", { staticClass: "block bethead" }, [
                    _c(
                      "div",
                      {
                        staticClass: "betoverview",
                        class: { single: bet.SB && bet.SB.IDFOBetType == "S" }
                      },
                      [
                        bet.SB && bet.SB.IDFOBetType == "S"
                          ? _c("div", { staticClass: "betttl whitetitle" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("BetSlip.tab.title.Single"))
                                )
                              ])
                            ])
                          : bet.SB && bet.SB.BetTypeExt
                          ? _c("div", { staticClass: "betttl whitetitle" }, [
                              _vm._v(_vm._s(bet.SB.BetTypeExt) + " "),
                              bet.SB && bet.SB.BetTypeSpread
                                ? _c("span", { staticClass: "spreadhint" }, [
                                    _vm._v(
                                      _vm._s(bet.SB.BetTypeSpread) +
                                        " " +
                                        _vm._s(_vm.$t("Statement.spreadHint"))
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : bet.SB && bet.SB.Units && bet.SB.Units > 1
                          ? _c("div", { staticClass: "betttl whitetitle" }, [
                              _vm._v(_vm._s(bet.SB.BetType) + " "),
                              bet.SB
                                ? _c("span", { staticClass: "unitshint" }, [
                                    _vm._v(
                                      "x" +
                                        _vm._s(bet.SB.Units) +
                                        " " +
                                        _vm._s(_vm.$t("Statement.unitsHint"))
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : bet.SB
                          ? _c("div", { staticClass: "betttl whitetitle" }, [
                              _vm._v(_vm._s(bet.SB.BetType))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "betrefs_align" }, [
                          bet.Status === "Open"
                            ? _c("div", { staticClass: "betrefs" }, [
                                _vm._v(
                                  "#" +
                                    _vm._s(bet.InvoiceSlip) +
                                    " - " +
                                    _vm._s(
                                      _vm._f("moment")(
                                        _vm._f("date")(
                                          bet.Created,
                                          "yyyy-MM-ddThh:mm:ss"
                                        ),
                                        _vm.dateFormats.longDateTime
                                      )
                                    )
                                )
                              ])
                            : _c("div", { staticClass: "betrefs" }, [
                                _vm._v(
                                  "#" +
                                    _vm._s(bet.InvoiceSlip) +
                                    " - " +
                                    _vm._s(
                                      _vm._f("moment")(
                                        _vm._f("date")(
                                          bet.Created,
                                          "yyyy-MM-ddThh:mm:ss"
                                        ),
                                        _vm.dateFormats.longDateTime
                                      )
                                    )
                                )
                              ])
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(bet.SB.Legs, function(leg) {
                    return _c(
                      "div",
                      {
                        staticClass: "block leg",
                        class:
                          "legstatus-" +
                          (leg.Status ? leg.Status.toLowerCase() : "xx")
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "betsporticon" },
                          [
                            _c("icon", {
                              attrs: {
                                name:
                                  "icon-" +
                                  (leg.IDFOSportType.split(" ")
                                    .join("")
                                    .toLowerCase() || "empty")
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "leginfo",
                            class: {
                              "leginfo-live":
                                bet.SB &&
                                bet.SB.BetState == "O" &&
                                _vm.liveEvents.filter(function(ev) {
                                  return ev.idfoevent == leg.IDFOEvent
                                }).length > 0
                            }
                          },
                          [
                            bet.SB && bet.SB.IDFOBetType == "S"
                              ? _c("div", { staticClass: "leginfo-top" }, [
                                  bet.Status === "Won"
                                    ? _c("span", {
                                        staticClass:
                                          "pd-icon pd-icon-top-prize-pool"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  bet.Status === "Lost"
                                    ? _c("span", {
                                        staticClass: "pd-icon pd-icon-sad-chip"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  bet.statusInner === "boughtback"
                                    ? _c("span", {
                                        staticClass:
                                          "pd-icon pd-icon-cashout-bet"
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(bet.SB.Legs[0].Event) +
                                      "\n          "
                                  )
                                ])
                              : _c("div", { staticClass: "leginfo-top" }, [
                                  bet.Status === "Won"
                                    ? _c("span", {
                                        staticClass:
                                          "pd-icon pd-icon-top-prize-pool"
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(leg.Event) +
                                      "\n          "
                                  )
                                ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "leginfo-main" }, [
                              _c("span", { staticClass: "leginfo-stats" }, [
                                leg.PriceUp && leg.PriceDown
                                  ? _c("div", { staticClass: "leginfo-odds" }, [
                                      _vm._v(_vm._s(_vm._f("formatOdds")(leg)))
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(_vm._s(leg.SelectionExt) + "\n          ")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "leginfo-sub" }, [
                              _vm._v(_vm._s(leg.Market))
                            ]),
                            _vm._v(" "),
                            bet.SB &&
                            bet.SB.BetState != "O" &&
                            leg.Status &&
                            leg.Status.toLowerCase() === "void"
                              ? _c(
                                  "div",
                                  { staticClass: "legribbon legribbon-void" },
                                  [_vm._v("void")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            bet.SB &&
                            bet.SB.BetState == "O" &&
                            _vm.liveEvents.filter(function(ev) {
                              return ev.idfoevent == leg.IDFOEvent
                            }).length > 0
                              ? _c("div", { staticClass: "legliveicon" }, [
                                  _vm._v(" LIVE")
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "block result" }, [
                    _c(
                      "div",
                      {
                        staticClass: "betodds",
                        class: { hidden: bet.SB && !bet.SB.Odds }
                      },
                      [
                        _c("span", { staticClass: "hint" }, [
                          _vm._v(_vm._s(_vm.$t("BetSlip.oddsprice")))
                        ]),
                        _vm._v(" "),
                        bet.SB && bet.SB.Odds && bet.SB.Odds !== 0
                          ? _c("div", { staticClass: "value" }, [
                              _vm._v(_vm._s(_vm._f("formatOdds")(bet.SB)))
                            ])
                          : _c("div", { staticClass: "value" }, [_vm._v(" ")])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "betstake" }, [
                      _c("span", { staticClass: "hint" }, [
                        _vm._v("Bet Amount")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        bet.SB.Stake
                          ? _c("span", [
                              _vm._v(_vm._s(_vm._f("currency")(bet.SB.Stake)))
                            ])
                          : _c("span", [_vm._v("-")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "betreturn", class: bet.Status }, [
                      _c("div", { staticClass: "content-wrapper" }, [
                        bet.Status === "Open" &&
                        bet.SB &&
                        bet.SB.Potential &&
                        bet.SB.Potential > 0
                          ? _c("span", { staticClass: "hint" }, [
                              _vm._v(_vm._s(_vm.$t("Statement.MaxWin")))
                            ])
                          : bet.statusInner === "boughtback"
                          ? _c("span", { staticClass: "hint" }, [
                              _vm._v(_vm._s(_vm.$t("Statement.CASHEDOUT")))
                            ])
                          : _c("span", { staticClass: "hint" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Statement." + bet.StatusText))
                              )
                            ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "value" }, [
                          bet.Status === "Open" &&
                          bet.SB &&
                          bet.SB.Potential &&
                          bet.SB.Potential > 0 &&
                          bet.SB.Stake
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("currency")(
                                      bet.SB.Potential - bet.SB.Stake
                                    )
                                  )
                                )
                              ])
                            : bet.Status === "Open"
                            ? _c("span", [_vm._v("-")])
                            : bet.Status === "Lost"
                            ? _c("span", [
                                _vm._v(_vm._s(_vm._f("currency")(0)))
                              ])
                            : bet.Status !== "Open" && bet.SB.Return != null
                            ? _c("span", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("currency")(bet.SB.Return))
                                  )
                                ])
                              ])
                            : _c("span", [_vm._v("-")])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  bet.Status === "Open" && bet.SB && bet.Quote && bet.Quote > 0
                    ? _c("div", { staticClass: "block buyback" }, [
                        _c(
                          "button",
                          {
                            staticClass: "stmnt-btn sb-green",
                            on: {
                              click: function($event) {
                                return _vm.quoteBuyBack(bet.SB.IDFOBet)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "CASH OUT " +
                                _vm._s(_vm._f("currency")(bet.Quote))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.bb &&
                        _vm.bb.bet &&
                        _vm.bb.bet.SB &&
                        _vm.bb.bet.SB.IDFOBet === bet.SB.IDFOBet
                          ? _c(
                              "div",
                              { staticClass: "bb-loading" },
                              [_c("circle-loader")],
                              1
                            )
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm.historyStatus &&
            _vm.historyStatus.error &&
            _vm.historyStatus.error === "SessionTimeout"
              ? _c("div", { staticClass: "stmnt-block note" }, [
                  _vm._v(_vm._s(_vm.$t("Statement.SessionTimeout")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.historyStatus && _vm.historyStatus.fetching === true
              ? _c(
                  "div",
                  { staticClass: "stmnt-block loading" },
                  [_c("circle-loader")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (!_vm.historyStatus || _vm.historyStatus.fetching === false) &&
            _vm.history &&
            _vm.history.length &&
            _vm.pageNumber + 1 < _vm.pageCount &&
            _vm.pageCount > 0
              ? _c("div", { staticClass: "stmnt-ctrls" }, [
                  _vm.pageNumber + 1 < _vm.pageCount && _vm.pageCount > 0
                    ? _c(
                        "button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.loadMore()
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "btn__content" }, [
                            _vm._v(_vm._s(_vm.$t("Statement.LoadMoreDown")))
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.history && _vm.history.length
              ? _c("div", { staticClass: "note note-pagehint" }, [
                  _vm._v(
                    "showing pages 1-" +
                      _vm._s(_vm.pageNumber + 1) +
                      " of " +
                      _vm._s(_vm.pageCount)
                  )
                ])
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6813858d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6813858d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Statement.vue
// module id = null
// module chunks = 